<span class="add-new-badge">{{ label }}</span>
